import { addDays, getISOWeek, getISOWeekYear, startOfWeek } from 'date-fns';
import type { DateRange } from 'react-day-picker';

type Labels = {
  week: string;
  showCalendar: string;
};

export function formatWeekRangeLabel(
  range: DateRange | undefined,
  labels: Labels,
): string {
  if (!range?.from) {
    return labels.showCalendar;
  }

  const from = range.from;
  const to = range.to ?? from;

  const startYear = getISOWeekYear(addDays(from, 3));
  const startWeek = getISOWeek(from);

  const toWeekStart = startOfWeek(to, { weekStartsOn: 1 });
  const endYear = getISOWeekYear(addDays(toWeekStart, 3));
  const endWeek = getISOWeek(toWeekStart);

  if (startYear === endYear) {
    return `${startYear} - ${labels.week} ${startWeek} - ${endWeek}`;
  }

  return `${startYear} - ${labels.week} ${startWeek} - ${endYear} - ${labels.week} ${endWeek}`;
}
